export default "__VITE_ASSET__9WcCanPN__"